import { ButtonAddCreator, Filters, ViewData } from './components';
import { LayoutPage } from '@/components/hoc';
import { Separator } from '@/components/ui';
import { ScanBarcode } from 'lucide-react';
import { useDocumentTitle } from '@/hooks';
import { cn } from '@/lib/utils';

const ReferralPage = () => {

	useDocumentTitle({ title: 'Parrainage' });

	return (
		<LayoutPage
			header={{
				description: 'Gestion des parrainages, codes promo et créateurs de contenu.',
				title: 'Parrainage'
			}}
			breadcrumb={{ title: 'Parrainage' }}
			icon={ScanBarcode}>
			<div className='pt-3 md:pt-5 flex flex-col space-y-3'>
				<div className={cn(
					'flex flex-col space-y-1',
					'md:flex-row md:items-end md:justify-between',
				)}>
					<Filters />
					<ButtonAddCreator />
				</div>
				<Separator className='bg-muted' />
				<ViewData />
			</div>
		</LayoutPage>
	);

};

export default ReferralPage;
